'use client';

import { useParams } from 'react-router-dom';
import ProfilePage from '../../components/profile-page';

/**
 * SPA 平台个人中心：`/profile`（无游戏前缀）。
 * 游戏内入口仍走 `/:game/profile`（SpaProfilePage）。
 */
export default function SpaPlatformProfilePage() {
  return <ProfilePage key="platform" />;
}
